<template>
  <div class="main">
    <GoBack :name="`关于我们`" :type="2" :path="`/mobile/my`"></GoBack>

    <div
      class="content-box"
      v-for="(item, index) in list"
      :key="index"
      @click="changeActive(index)"
    >
      <div class="p-list">
        <div v-html="item.content"></div>
      </div>
    </div>
  </div>
</template>
<script>
import GoBack from "@/components/goBack";
import { getQuestions } from "@/api/mobile";
export default {
  data() {
    return {
      list: [
        {
          name: "关于爱答卷",
          pList: [
            {
              title:
                "1.广泛的用户参与：爱答卷为广大网民提供了参与调查和发表意见的机会。任何用户都可以注册并参与各种调查项目，表达自己的观点和意见。",
            },
            {
              title:
                "2.趣味性和有报酬的调查项目：爱答卷提供趣味性的调查项目，使用户的参与更加有趣和愉悦。同时，用户参与调查还可以获得一定的报酬。",
            },
            {
              title:
                "3.快速有效的沟通渠道：为消费者和企业之间提供了快速有效的沟通渠道。消费者可以直接向企业反馈意见和建议，企业也可以通过爱答卷了解消费者的需求和反馈。",
            },
            {
              title:
                "4.专业水平的在线市场调研：爱答卷拥有专业的团队和技术，能够为企业提供高质量的在线市场调研服务。通过各种调查方法和工具，帮助企业获取准确、全面的市场信息，为企业决策提供有力的参考依据。",
            },
          ],
        },
      ],
      active: null,
    };
  },
  components: { GoBack },
  methods: {
    changeActive(index) {
      if (index === this.active) {
        this.active = null;
      } else {
        this.active = index;
      }
    },
  },
  created() {
    getQuestions({ categoryId: 1 }).then((res) => {
      if (res.code === 200) {
        this.list = res.data.list;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.main {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-color: #f8f8fa;
  .content-box {
    width: calc(100% - 30px);
    margin-left: 15px;
    background: #ffffff;
    border-radius: 0px 0px 0px 0px;
    overflow: hidden;
    margin-bottom: 12px;
    transition: max-height ease 0.75s;
    .content-herder {
      height: 42px;
      display: flex;
      align-items: center;
      position: relative;
      width: 100%;
      border-bottom: 1px solid #fff;
      box-sizing: border-box;
      .wen {
        width: 20px;
        height: 20px;
        margin-left: 7px;
      }
      .name {
        margin-left: 7px;
        color: #666666;
        font-size: 14px;
      }
      .arrow {
        position: absolute;
        width: 16px;
        height: 16px;
        right: 18px;
        transform: rotate(180deg);
        transition: transform ease 0.75s;
      }
    }
    .p-list {
      padding: 10px 9px;
      color: #232323;
      font-size: 14px;
      line-height: 20px;
    }
  }
  .content-active {
    max-height: 500px;
    .content-herder {
      border-bottom: 1px solid #eaeaea;
      .arrow {
        transform: rotate(0deg);
      }
    }
  }
}
</style>